/* eslint-disable */
import classNames from 'classnames';
import CheckIcon from 'images/v5/icons/circle/tick.svg';
import React from 'react';
import { useParams } from 'react-router';
import styles from './TabsWizard.module.scss';
const TabsWizard = ({ size = 'm', tabs, activeTab, onClick }) => {
    const params = useParams();
    const handleOnClick = (id) => {
        onClick(id);
    };
    return (React.createElement("div", { className: classNames(styles.wrap, styles[size]) }, tabs.map((tab, index) => (React.createElement(React.Fragment, { key: index },
        React.createElement("button", { className: classNames(styles.tab, styles[size], {
                [styles.active]: tab.id === activeTab || tab.id === params.tab,
                [styles.disabled]: tabs.slice(0, index).some((t) => !t.completed),
            }), disabled: tabs.slice(0, index).some((t) => !t.completed), onClick: () => handleOnClick(tab.id) },
            tab.completed && !tab.error ? (React.createElement("span", { className: styles.completed },
                React.createElement(CheckIcon, null))) : (React.createElement("p", { className: styles.number }, index + 1)),
            React.createElement("p", { className: styles.label }, tab.label)),
        index < tabs.length - 1 && React.createElement("div", { className: styles.connector }))))));
};
export default TabsWizard;
